import gql from 'graphql-tag';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import HttpLinkServices from '../../../services/HttpLinkServices';

const dam_client = new ApolloClient({
  link: HttpLinkServices.dam,
  cache: new InMemoryCache(),
});

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const cms_client = new ApolloClient({
  link: HttpLinkServices.cms,
  cache: new InMemoryCache(),
});

const analytics_client = new ApolloClient({
  link: HttpLinkServices.analytics,
  cache: new InMemoryCache(),
});

const GET_DAM = gql`
  query getDam($module_name: String!){
    assets_collections(limit:5,order:"DESC",module_name:$module_name) {
      assets{
        id, title, asset, directlink
      }
    }
  }
`;

const GET_COURSES = gql`{
    courses_collections(type:"online", limit: 12){
      courses{
        id, title, thumbnail, description, hours, minutes
      }
    }
  }
`;

const GET_VIDEOS_TRENDING = gql`{
  videos_trending(limit: 12){
    videos{
      id, title, thumbnail
    }
  }
}
`;

const GET_TESTIMONY = gql`{
contents_collections(limit:4,order:"DESC",module_name:"Testimony") {
    contents{
      id, title, content, thumbnail, directlink
    }
  }
}
`;


const ANALYTICS_INSERT_BANNER_CLICK = gql`
  mutation createBanner($banner_id: Int!, $banner_title: String!) {
    createBanner(input:{banner_id: $banner_id, banner_title: $banner_title}) {
    id
    }
  }
`;

export {
  dam_client,
  lms_client,
  cms_client,
  analytics_client,
  GET_DAM,
  GET_COURSES,
  GET_VIDEOS_TRENDING,
  GET_TESTIMONY,
  ANALYTICS_INSERT_BANNER_CLICK,
};



// WEBPACK FOOTER //
// ./src/views/Home/apollo/index.jsx